var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.99995V0.199951H0V21.8H24V4.99995H12ZM9.6 19.4H2.4V17H9.6V19.4ZM9.6 14.6H2.4V12.2H9.6V14.6ZM9.6 9.79995H2.4V7.39995H9.6V9.79995ZM9.6 4.99995H2.4V2.59995H9.6V4.99995ZM21.6 19.4H12V7.39995H21.6V19.4ZM19.2 9.79995H14.4V12.2H19.2V9.79995ZM19.2 14.6H14.4V17H19.2V14.6Z",
    fill: "#F2F2F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationIcon);
export default __webpack_public_path__ + "static/media/Organization_icon.0a1446b8db4706b3f9ed6c554c45adaf.svg";
export { ForwardRef as ReactComponent };